<template>
  <v-row>
    <v-col>
      <!-- Identifier && status -->
      <div class="mb-4 mt-4">
        <div class="d-block">
          <v-row>
            <v-col cols="12" sm="2">
              <!-- Bill Search Component -->
              <v-autocomplete
                :autocomplete="autocompleteValueLocal"
                v-model="selectedMission"
                class="mr-2 mt-4 to-upper"
                :items="missions"
                :search-input.sync="search_mission"
                item-text="identifier"
                item-value="id"
                :loading="isLoadingSearchRegMissions"
                :label="$t('scheduler.search_bill')"
                :placeholder="$t('scheduler.start_typing')"
                return-object
                :clearable="selectedMission ? true : false"
                clear-icon="mdi-close"
                v-on:keydown="handleInput($event, 'alphanumeric', 20)"
                v-on:keydown.enter.prevent=""
                ref="missionDropdown"
                @click:clear="
                  resetPageData();
                  search_mission = null;
                "
                :readonly="
                  selectedMission !== null && selectedMission !== undefined
                "
                :hide-no-data="true"
                dense
                hide-details
                :style="{
                  maxWidth: '250px',
                  minWidth: '250px',
                  fontSize: '16px',
                }"
              >
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content @click="selectMissionFromObject(item)">
                    <span v-if="item.mission_type" class="mission_type">
                      {{ $t("mission.types." + item.mission_type.key) }}
                    </span>
                    <br />
                    <span>
                      <strong>{{ item.identifier }}</strong>
                    </span>
                    <br />
                    <span class="client_name" v-if="item.client">
                      {{ item.client.name }}
                      {{ item.client.first_name ? item.client.first_name : "" }}
                    </span>
                  </v-list-item-content>
                </template>
                <template #prepend-inner> </template>
              </v-autocomplete>
            </v-col>
            <v-spacer></v-spacer>
            <!-- Mission Total Time on Mission -->
            <!-- <v-col>
                <DateInput
                    v-model="total_time"
                    :label="$t('mission.total_time')"
                    :hide-details="true"
                    :classData="'mr-2'"
                />
            </v-col> -->
            <!-- Mission Status -->
            <v-col v-if="selectedMission" cols="12" sm="2">
              <v-select
                :disabled="!isAdmin"
                :autocomplete="autocompleteValueLocal"
                v-model="status_id"
                :items="missionStatuses"
                item-text="text"
                class="to-upper"
                item-value="id"
                return-object
                :label="$t('mission.status')"
                :background-color="setMissionRowColorClass(status_id, true)"
              >
                <!-- Item slot for dropdown options -->
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item
                    v-bind="attrs"
                    v-on="on"
                    :class="setMissionRowColorClass(item, true)"
                    class="pa-0 ma-0 pl-2"
                    style="color: black !important; width: 100%"
                  >
                    <v-list-item-content>
                      {{ item.text }}
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </div>
      </div>
      <!-- Date time row and distance and km total -->
      <div v-if="selectedMission" >
        <div class="d-block">
          <v-row>
            <!-- Mission For Date -->
            <v-col>
              <!-- <DateInput
                    v-model="for_date"
                    :label="$t('mission.for_date')"
                    :hide-details="true"
                    :classData="'mr-2'"
                /> -->
              <v-text-field
                class="to-upper right-aligned-input shrink"
                :label="$t('mission.for_date')"
                v-model="for_date"
                type="datetime-local"
              ></v-text-field>
            </v-col>
            <!-- Mission Started At -->
            <v-col>
              <!-- <DateInput
                    v-model="started_at"
                    :label="$t('mission.started_at')"
                    :hide-details="true"
                    :classData="'mr-2'"
                /> -->
              <v-text-field
                class="to-upper right-aligned-input shrink"
                :label="$t('mission.started_at')"
                v-model="started_at"
                type="datetime-local"
              ></v-text-field>
            </v-col>
            <!-- Mission Arrived at mission Place -->
            <v-col>
              <v-text-field
                class="to-upper right-aligned-input shrink"
                :label="$t('mission.check_in_time')"
                v-model="check_in_time"
                type="datetime-local"
              ></v-text-field>
              <!-- <DateInput
                    v-model="check_in_time"
                    :label="$t('mission.check_in_time')"
                    :hide-details="true"
                    :classData="'mr-2'"
                /> -->
            </v-col>
            <!-- Mission Finished At -->
            <v-col>
              <v-text-field
                class="to-upper right-aligned-input shrink"
                :label="$t('mission.finished_at')"
                v-model="finished_at"
                type="datetime-local"
              ></v-text-field>
            </v-col>

            <!-- Mission Total Time on Mission -->
            <v-col cols="12" sm="2">
              <custom-money-input
                :autocomplete="autocompleteValueLocal"
                class="to-upper right-aligned-input shrink"
                outlined
                :label="$t('mission.total_time')"
                v-model="total_time"
                :suffix="$t('suffix.hours')"
                v-bind:properties="{
                  readonly: false,
                  disabled: false,
                  outlined: false,
                  placeholder: '0.0',
                }"
                v-bind:options="{
                  locale: userLanguageId,
                  length: 12,
                  precision: 1,
                  empty: 0.0,
                }"
              />
            </v-col>
            <!-- Mission Distance -->
            <v-col cols="12" sm="2">
              <custom-money-input
                :autocomplete="autocompleteValueLocal"
                class="to-upper right-aligned-input shrink"
                outlined
                :label="$t('mission.total_distance')"
                v-model="total_distance"
                :suffix="$t('suffix.km')"
                v-bind:properties="{
                  readonly: false,
                  disabled: false,
                  outlined: false,
                  placeholder: '0.0',
                }"
                v-bind:options="{
                  locale: userLanguageId,
                  length: 12,
                  precision: 1,
                  empty: 0.0,
                }"
              />
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Client -->
      <div class="">
        <div class="d-block">
          <heading-title :title="$t('mission.client')"></heading-title>
        </div>
        <div class="d-block">
          <v-row>
            <v-col>
              <v-combobox
                class="to-upper"
                :autocomplete="autocompleteValueLocal"
                role="presentation"
                ref="clientName"
                v-model="client_name"
                :items="client_names"
                item-value="id"
                item-text="name"
                :label="$t('billings.comp_name')"
                required
                v-on:keydown="handleInput($event, 'everything', 50)"
                :search-input.sync="search_client"
                no-filter
                v-on:keydown.enter.prevent="fetchClientsListDebounced()"
                return-object
                persistent-hint
                hide-details="auto"
                hint="."
              >
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content class="">
                    <p class="client_name">
                      <strong>
                        <span
                          v-if="
                            item.client && item.client.representative_company_id
                          "
                        >
                          <v-icon class="client_icon">mdi-domain</v-icon>
                        </span>
                        <span v-else>
                          <v-icon class="client_icon"
                            >mdi-account</v-icon
                          > </span
                        >{{ item.name }} {{ item.first_name }}
                      </strong>
                    </p>
                    <p class="client_detail">
                      <!-- Email -->
                      <span v-if="item.email" class="mr-2">
                        <v-icon x-small class="mr-1">mdi-email</v-icon>
                        {{ item.email }}
                      </span>

                      <!-- GSM -->
                      <span v-if="item.gsm" class="mr-2">
                        <v-icon x-small class="mr-1">mdi-phone</v-icon>
                        {{ item.gsm }}
                      </span>

                      <!-- Phone -->
                      <span v-if="item.phone_no" class="mr-2">
                        <v-icon x-small class="mr-1">mdi-phone</v-icon>
                        {{ item.phone_no }}
                      </span>

                      <!-- Website -->
                      <span v-if="item.web" class="mr-2">
                        <v-icon x-small class="mr-1">mdi-web</v-icon>
                        {{ item.web }}
                      </span>
                    </p>
                    <!-- Third Line -->
                    <p class="client_detail">
                      <!-- Vehicles -->
                      <span
                        v-if="item.vehicles && item.vehicles.length > 0"
                        class="mr-2"
                      >
                        <v-icon x-small class="mr-1">mdi-car</v-icon>
                        {{ item.vehicles[0].registration_number }}
                        <span v-if="item.vehicles.length > 1"> ... </span>
                      </span>

                      <!-- Company Address -->
                      <span
                        v-if="
                          item.company_address &&
                          item.company_address.length > 0
                        "
                        class="mr-2"
                      >
                        <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                        {{
                          item.company_address[0].address.human_readable_address
                        }}
                      </span>

                      <!-- Client Address -->
                      <span
                        v-if="
                          item.client_address && item.client_address.length > 0
                        "
                        class="mr-2"
                      >
                        <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                        {{
                          item.client_address[0].address.human_readable_address
                        }}
                      </span>
                    </p>
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- What to do & Price & Open Timer-->
      <div>
        <div class="d-block">
          <heading-title :title="$t('mission.what_to_do')"></heading-title>
        </div>
        <div class="d-block">
          <v-row>
            <!-- Mission Types -->
            <v-col>
              <v-radio-group class="mt-0" v-model="selectedMissionType" row>
                <v-radio
                  v-for="(mi_type, index) in missionTypes"
                  :key="index"
                  :label="$t('mission.types.' + mi_type.key)"
                  :value="mi_type.id"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <!--  Reference -->
            <v-col cols="12" sm="2">
              <v-text-field
                class="to-upper mt-0 pt-0"
                v-model="reference"
                :label="$t('mission.reference')"
                hide-details="true"
                :required="true"
              ></v-text-field>
            </v-col>
            <!-- Price -->
            <v-col cols="12" sm="1">
              <custom-money-input
                :autocomplete="autocompleteValueLocal"
                class="to-upper right-aligned-input shrink"
                hide-details="auto"
                outlined
                dense
                :label="$t('mission.price')"
                v-model="price"
                v-bind:properties="{
                  prefix: currencySymbol,
                  readonly: false,
                  disabled: false,
                  outlined: false,
                  placeholder: getDecimalNumber() == 2 ? '0.00' : '0.000',
                  dense: true,
                  hideDetails: 'auto',
                }"
                v-bind:options="{
                  locale: userLanguageId,
                  length: 12,
                  precision: getDecimalNumber(),
                  empty: getDecimalNumber() == 2 ? 0.0 : 0.0,
                }"
              />
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Reason -->
      <div class="mb-0 mt-0">
        <div class="d-block">
          <heading-title :title="$t('mission.reason')"></heading-title>
        </div>
        <div class="d-block to-upper mt-n3">
          <v-text-field v-model="reason"></v-text-field>
        </div>
      </div>

      <!-- Source Location -->
      <div>
        <div class="d-block">
          <heading-title
            :title="$t('mission.mission_location_section')"
          ></heading-title>
        </div>
        <div class="d-block">
          <v-row>
            <v-col class="pl-0">
              <AddressInput
                class="mt-n4"
                v-model="sourceLocation"
                :label="$t('mission.source_location')"
                :error-messages="
                  $store.state.validation && !$v.sourceLocation.required
                    ? [this.$t('mission.text_messages.required')]
                    : []
                "
              />
            </v-col>
            <v-col class="pl-0">
              <AddressInput
                class="mt-n4"
                v-model="destinationLocation"
                :label="$t('mission.destination_location')"
              />
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Contact Person -->
      <div class="mt-3">
        <v-row class="ml-1">
          <v-col cols="12" sm="4" class="pa-0 ma-0">
            <heading-title
              :title="$t('mission.mission_contact_section')"
            ></heading-title>
          </v-col>
          <v-col cols="12" sm="4" class="pa-0 ma-0">
            <heading-title
              :title="$t('mission.mission_vehicle_section')"
            ></heading-title>
          </v-col>
        </v-row>
        <v-row class="ml-1">
          <v-row>
            <v-col cols="12" sm="2">
              <v-text-field
                class="to-upper"
                v-model="contact.name"
                :label="$t('mission.contact_name')"
                :required="true"
                :error-messages="
                  $store.state.validation && !$v.contact.name.required
                    ? [this.$t('mission.text_messages.required')]
                    : []
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <!-- <v-text-field
                class="to-upper"
                v-model="contact.gsm"
                :label="$t('mission.contact_gsm')"
                :required="true"
              ></v-text-field> -->

              <vue-tel-input-vuetify
                :preferredCountries="preferredCountry"
                :filterCountries="onlyCountries"
                :disabledFetchingCountry="true"
                validCharactersOnly
                :label="$t('mission.contact_gsm')"
                :inputOptions="{ showDialCode: true, tabindex: 0 }"
                :mode="'international'"
                v-model="contact.gsm"
              ></vue-tel-input-vuetify>
            </v-col>

            <v-col cols="12" sm="8" class="mt-2 pr-6 pl-0">
              <create-edit-vehicle
                ref="vehicleComp"
                :comp_vehicle_type.sync="vehicle.vehicle_type_id"
                :comp_registration_no.sync="vehicle.registration_number"
                :comp_brand.sync="vehicle.brand"
                :comp_model.sync="vehicle.model"
                :comp_km.sync="vehicle.km"
                :comp_reg_date.sync="vehicle.registration_date"
                :comp_vin.sync="vehicle.vin"
                :comp_color.sync="vehicle.color"
                :comp_is_leasing.sync="vehicle.is_leasing"
                :show_creditor_input="false"
                :show_driver_input="false"
                :show_color="true"
                :showVehicleLabel="false"
                :showKm="false"
                :showVin="false"
                :showEditVehicleButton="false"
                :reg_no_compulsory="true"
              />
            </v-col>
          </v-row>
        </v-row>
      </div>

      <!-- Note -->
      <div class="mb-2 mt-2">
        <div class="d-block">
          <heading-title :title="$t('mission.note')"></heading-title>
        </div>
        <div class="d-block to-upper">
          <wysiwyg
            class="to-upper"
            v-model="note"
            row="5"
            @input="handleUppercase"
          />
        </div>
      </div>

      <!-- Towing Partner -->
      <div class="mb-2">
        <div class="d-block">
          <v-row>
            <v-col cols="12" sm="2" class="mb-0 pb-0">
              <heading-title
                :title="$t('mission.towing_partner')"
              ></heading-title>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2" class="mb-0 pb-0">
              <div class="d-flex justify-end align-center mt-0">
                <span class="mr-2 text-orange">{{
                  $t("mission.notify_partner")
                }}</span>
                <v-simple-checkbox
                  v-model="notify_partners"
                  hide-details
                  class="ma-0 pa-0"
                  value="false"
                  label=""
                  color="warning"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="d-block">
          <v-row>
            <!-- Towing Company -->
            <v-col>
              <v-autocomplete
                :disabled="
                  status_id &&
                  typeof status_id == 'object' &&
                  status_id.key == 'in_mission'
                "
                :autocomplete="autocompleteValueLocal"
                ref="towingPartnerName"
                v-model="towingPartner"
                :label="$t('clients.owner')"
                :items="towingPartners"
                item-value="id"
                item-text="name"
                required
                class="to-upper clickable_label"
                v-on:keydown="handleInput($event, 'everything', 50)"
                :search-input.sync="searchTowingPartner"
                no-filter
                v-on:keydown.enter.prevent=""
                return-object
                single-line
                hide-no-data
                @click:clear="removeEmployeeAndVehicle()"
                clearable
                @change="
                  fetchTowingPartnerEmployeesListDebounced(true);
                  fetchTowingVehiclesListDebounced(true);
                "
              >
                <template slot="selection" slot-scope="{ item }">
                  <span class="text-no-wrap">
                    {{ item.name }} {{ item.first_name ? item.first_name : "" }}
                  </span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <p class="towing_name">
                      {{ item.name }} {{ item.first_name }}
                    </p>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <!-- Towing Employee -->
            <v-col>
              <v-autocomplete
                :disabled="
                  !towingPartner ||
                  (status_id &&
                    typeof status_id == 'object' &&
                    status_id.key == 'in_mission')
                "
                :autocomplete="autocompleteValueLocal"
                ref="towingPartnerEmployeeName"
                v-model="towingPartnerEmployee"
                :label="$t('mission.employee')"
                :items="towingPartnerEmployees"
                item-value="id"
                item-text="name"
                required
                class="to-upper clickable_label"
                v-on:keydown="handleInput($event, 'everything', 50)"
                :search-input.sync="searchTowingPartnerEmployees"
                no-filter
                v-on:keydown.enter.prevent=""
                return-object
                single-line
                hide-no-data
                clearable
                @click:clear="removeVehicle()"
                @change="fetchTowingPartnerEmployeesListDebounced(true)"
              >
                <template slot="selection" slot-scope="{ item }">
                  <span class="text-no-wrap">
                    {{ item.name }} {{ item.first_name ? item.first_name : "" }}
                  </span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <p class="towing_name">
                      {{ item.name }} {{ item.first_name }}
                    </p>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <!-- Towing Vehicle -->
            <v-col>
              <v-autocomplete
                :disabled="
                  !towingPartner ||
                  !towingPartnerEmployee ||
                  (status_id &&
                    typeof status_id == 'object' &&
                    status_id.key == 'in_mission')
                "
                :autocomplete="autocompleteValueLocal"
                ref="towingPartnerVehicle"
                v-model="towingVehicle"
                :label="$t('mission.towing_vehicle')"
                :items="towingVehicles"
                item-value="id"
                item-text="name"
                required
                class="to-upper clickable_label"
                v-on:keydown="handleInput($event, 'everything', 50)"
                :search-input.sync="searchTowingVehicle"
                no-filter
                v-on:keydown.enter.prevent=""
                return-object
                clearable
                hide-no-data
                single-line
              >
                <template slot="selection" slot-scope="{ item }">
                  <span class="text-no-wrap">
                    {{ item.registration_number }}
                  </span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <p class="registration_number">
                      {{ item.registration_number }}
                    </p>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </div>

      <mission-tabs
        v-if="selectedMission && selectedMission.id"
        :mission="selectedMission"
        @application-data="updateSelectedApplicant"
      ></mission-tabs>
    </v-col>

    <confirmation-model
      v-if="confirmationDialog"
      :showDialog.sync="confirmationDialog"
      :openedForOperation.sync="confirmationDialogOperation"
      :text.sync="confirmationDialogConfirmationText"
      :trueText.sync="confirmationDialogTrueText"
      :falseText.sync="confirmationDialogFalseText"
      @buttonClicked="confirmationButtonClicked"
    ></confirmation-model>
    <v-btn @click="onSubmit()" class="d-none" id="submit-mission"></v-btn>
    <v-btn @click="onDelete()" class="d-none" id="delete-mission"></v-btn>
    <v-btn
      @click="confirmMakeBillPopUp()"
      class="d-none"
      id="make-bill-for-selected-mission"
    ></v-btn>
    <v-btn
      @click="confirmCancelMissionPopUp()"
      class="d-none"
      id="cancel-selected-mission"
    ></v-btn>
  </v-row>
</template>

<script>
import AddressInput from "@/components/AddressInput";
import CreateEditVehicle from "@/components/Vehicles/CreateEditVehicle";
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import { MISSION_MODE } from "@/config";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CustomMoneyInput from "@/components/CustomInputs/MoneyInput";
import { ADD_MODE } from "@/config";
import Tabs from "@/components/Mission/Tabs";
import ConfirmationModel from "@/components/ConfirmationModel";
import VueTelInputVuetify from "@/components/PhoneNumberInput";
// import DateInput from "@/components/DateInput.vue";
import moment from "moment";

export default {
  mixins: [validationMixin],
  name: "Mission",
  components: {
    "vue-tel-input-vuetify": VueTelInputVuetify,
    AddressInput,
    CreateEditVehicle,
    "custom-money-input": CustomMoneyInput,
    "mission-tabs": Tabs,
    ConfirmationModel,
  },
  validations: {
    selectedMissionType: {
      required: required,
    },
    sourceLocation: {
      required: required,
    },
    // destinationLocation: {
    //     required: required
    // },
    contact: {
      name: {
        required,
      },
    },
  },
  data() {
    return {
      allowContinueSearch: true,
      isLoadingSearchRegMissions: null,
      missions: [],
      search_mission: null,
      search_client: null,
      client_name: null,
      client_names: [],
      autocompleteValueLocal: "off",
      selectedMission: null,
      //Mission Related Date Times
      for_date: null,
      started_at: null,
      check_in_time: null,
      finished_at: null,
      total_time: null,
      total_distance: null,

      identifier: null,

      // Towing Partner
      towingPartner: null,
      towingPartners: [],
      searchTowingPartner: null,

      towingPartnerEmployee: null,
      towingPartnerEmployees: [],
      searchTowingPartnerEmployees: null,

      // Towing Vehicle
      towingVehicle: null,
      towingVehicles: [],
      searchTowingVehicle: null,

      selectedMissionType: null,
      sourceLocation: null,
      destinationLocation: null,
      reference: null,
      selectionOpenTime: null,
      price: null,

      // Contact
      contact: {
        id: null,
        name: null,
        phone: null,
        gsm: null,
      },

      // Vehicle
      vehicle: {
        id: null,
        vehicle_type_id: null,
        registration_number: null,
        brand_id: null,
        model: null,
        km: null,
        registration_date: null,
        creditor_id: null,
        vin: null,
        color: null,
        is_leasing: null,
      },

      note: null,
      reason: null,
      applications: [],

      header: {
        Authorization: "Bearer " + this.$store.state.AccessToken,
      },

      confirmationDialog: false,
      confirmationDialogConfirmationText: null,
      confirmationDialogFalseText: null,
      confirmationDialogTrueText: null,
      confirmationDialogButtonClickedIs: null,
      confirmationDialogOperation: null,
      confirmationDialogData: null,

      status_id: null,
      missionStatuses: [],

      notify_partners: true,
    };
  },
  async created() {
    await this.getMissionTypes();
    await this.getStatuses();

    if (this.$store.state.editId) {
      this.getMission();
    } else {
      let currentDate = moment(moment().format("YYYY-MM-DD HH:mm:ss"))
        .tz(this.currentTimeZone)
        .format("YYYY-MM-DD HH:mm:ss");
      this.for_date = currentDate;

      this.$store.commit("setFormMode", ADD_MODE);
      this.fetchTowingPartnersListDebounced(true);
    }
  },
  methods: {
    handleUppercase() {
      const editorEl =
        this.$refs.editor?.$el?.querySelector("[contenteditable]");
      if (editorEl) {
        const text = editorEl.innerText.toUpperCase();
        editorEl.innerText = text;
        this.note = text;
      }
    },
    async getStatuses() {
      await this.getCodes("mission_statuses", "mission.statuses").then(
        (data) => {
          this.missionStatuses = data.filter((element) => {
            return !element.key.includes("selection");
          });
        }
      );
    },
    updateSelectedApplicant() {
      this.getMission();
      //   if (data?.towing_partner) {
      //     this.towingPartners = [data?.towing_partner];
      //     this.towingPartner = data?.towing_partner_id;
      //   }

      //   if (data?.vehicle) {
      //     this.towingVehicles = [data.vehicle];
      //     this.towingVehicle = data.vehicle_id;
      //   }
    },
    confirmMakeBillPopUp() {
      if (this.selectedMission && this.selectedMission.order_id == null) {
        this.$nextTick(() => {
          this.confirmationDialogConfirmationText = this.$t(
            "mission.text_messages.are_you_sure_you_want_to_make_bill"
          );
          this.confirmationDialogFalseText = this.$t("no");
          this.confirmationDialogTrueText = this.$t("yes");
          this.confirmationDialogOperation = "make_bill_for_mission";
          this.confirmationDialog = true;
        });
      } else if (
        this.selectedMission &&
        this.selectedMission.order_id != null
      ) {
        this.$store.commit("seteditId", this.selectedMission.order_id);
        this.$router.push("/billing/edit").catch(() => {});
      }
    },
    confirmCancelMissionPopUp() {
      if (this.selectedMission) {
        this.$nextTick(() => {
          this.confirmationDialogConfirmationText = this.$t(
            "mission.text_messages.are_you_sure_you_want_to_cancel_bill"
          );
          this.confirmationDialogFalseText = this.$t("no");
          this.confirmationDialogTrueText = this.$t("yes");
          this.confirmationDialogOperation = "cancel_bill";
          this.confirmationDialog = true;
        });
      }
    },
    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    makeBillForMission() {
      this.updateMission(this.makeData(), false).then((data) => {
        this.$store.commit("setSelectedMissionForBilling", data);
        this.$router.push("/billing/add").catch(() => {});
      });
    },
    cancelMission() {
      return new Promise((resolve, reject) => {
        axios
          .patch(
            API_BASE_URL + "/missions/" + this.$store.state.editId,
            {
              status_id: 10891006, // Cancelled , Cancelled By Client
            },
            {
              headers: this.header,
            }
          )
          .then(() => {
            this.$router.push("/mission").catch(() => {});
          })
          .catch(() => {
            reject();
          })
          .finally(() => {});
      });
    },
    removeEmployeeAndVehicle() {
      this.towingPartnerEmployee = null;
      this.towingPartnerEmployees = [];

      this.towingVehicle = null;
      this.towingVehicles = [];
    },
    removeVehicle() {
      this.towingVehicle = null;
      this.towingVehicles = [];
    },
    resetPageData() {
      this.$router.push("/mission/add").catch(() => {});
      this.$store.commit("setFormMode", ADD_MODE);
      this.isLoadingSearchRegMissions = null;
      this.missions = [];
      this.search_mission = null;
      this.search_client = null;
      this.client_name = null;
      this.client_names = [];
      this.selectedMission = null;

      this.identifier = null;

      // Towing Partner
      this.towingPartner = null;
      this.towingPartners = [];
      this.searchTowingPartner = null;
      // Towing Vehicle
      this.towingVehicle = null;
      this.towingVehicles = [];
      this.searchTowingVehicle = null;

      (this.towingPartnerEmployee = null),
        (this.towingPartnerEmployees = []),
        (this.searchTowingPartnerEmployees = null),
        (this.selectedMissionType = null);
      this.sourceLocation = null;
      this.destinationLocation = null;
      this.reference = null;
      this.selectionOpenTime = null;
      this.price = null;

      // Contact
      this.contact = {
        id: null,
        name: null,
        phone: null,
        gsm: null,
      };

      // Vehicle
      this.vehicle = {
        id: null,
        vehicle_type_id: null,
        registration_number: null,
        brand_id: null,
        model: null,
        km: null,
        registration_date: null,
        creditor_id: null,
        vin: null,
        color: null,
        is_leasing: null,
      };

      this.note = null;
      this.reason = null;
      this.applications = [];
    },
    fetchMissionSuggestedListDebounced() {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchMissionSuggestedList();
      }, 500); /* 500ms throttle */
    },
    fetchMissionSuggestedList() {
      if (!this.search_mission || typeof this.search_mission == "object") {
        this.isLoadingSearchRegMissions = false;
        return;
      }
      axios
        .get(
          API_BASE_URL +
            "/missions?page=1&items_per_page=20" +
            (this.search_mission
              ? "&search=" + encodeURIComponent(this.search_mission)
              : ""),
          { headers: this.header, signal: this.abortController() }
        )
        .then(({ data }) => {
          this.missions = data.data;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingSearchRegMissions = false;
        })
        .finally(() => (this.isLoadingSearchRegMissions = false));
    },
    getMission() {
      if (this.$store.state.editId) {
        axios
          .get(API_BASE_URL + "/missions/" + this.$store.state.editId, {
            headers: this.header,
          })
          .then(({ data }) => {
            console.log("mission data", data.data);
            this.selectMissionFromObject(data.data);
            this.$store.commit("setCurrentPageData", data.data);
          });
      } else {
        this.$router.push("/mission").catch(() => {});
      }
    },
    selectMissionFromObject(data) {
      this.$router.push("/mission/edit").catch(() => {});
      this.$store.commit("setFormMode", MISSION_MODE);
      let missionData = data;
      this.missions = [missionData];
      this.selectedMission = missionData;
      if (missionData) {
        this.status_id = missionData.status;
        this.client_names = [missionData.client];
        this.client_name = missionData.client;

        this.total_time = missionData.total_time;
        this.total_distance = missionData.total_distance;
        this.finished_at = missionData.finished_at;
        this.check_in_time = missionData.check_in_time;
        this.started_at = missionData.started_at;
        this.for_date = missionData.for_date;

        this.notify_partners = missionData.notify_partners ? true : false;

        // if (missionData?.towing_vehicle?.client) {
        //   this.towingPartners = [missionData.towing_vehicle.client];
        //   this.towingPartner = missionData.towing_vehicle.client_id;
        // }

        if (missionData.towing_partner) {
          this.towingPartners = [missionData.towing_partner];
          this.towingPartner = missionData.towing_partner;
        } else {
          this.fetchTowingPartnersListDebounced(true); // auto populate towing partners
        }

        if (missionData.towing_partner_employee_id) {
          this.towingPartnerEmployees = [missionData.towing_partner_employee];
          this.towingPartnerEmployee = missionData.towing_partner_employee;
        } else {
          this.fetchTowingPartnerEmployeesListDebounced(true); // auto populate towing employees
        }

        if (missionData.towing_vehicle) {
          this.towingVehicles = [missionData.towing_vehicle];
          this.towingVehicle = missionData.towing_vehicle_id;
        } else {
          this.fetchTowingVehiclesListDebounced(true); // auto populate towing vehicles
        }

        this.note = missionData.note;
        this.reason = missionData.reason;
        this.price = missionData.price;
        this.reference = missionData.reference;
        this.identifier = missionData.identifier;
        this.selectionOpenTime = missionData.selectionOpenTime;

        this.sourceLocation = missionData.source_location ?? null;
        this.destinationLocation = missionData.destination_location ?? null;

        this.contact.id = missionData?.object_vehicle?.client?.id;
        this.contact.name = missionData?.object_vehicle?.client?.name;
        this.contact.phone = missionData?.object_vehicle?.client?.phone;
        this.contact.gsm = missionData?.object_vehicle?.client?.gsm;

        this.selectedMissionType = missionData?.mission_type_id;

        this.vehicle = missionData?.object_vehicle
          ? {
              id: missionData?.object_vehicle?.id,
              vehicle_type_id: missionData?.object_vehicle?.vehicle_type,
              registration_number: missionData?.object_vehicle,
              brand_id: missionData?.object_vehicle?.brand,
              model: missionData?.object_vehicle?.model,
              km: missionData?.object_vehicle?.km,
              creditor_id: missionData?.object_vehicle?.creditor_id,
              vin: missionData?.object_vehicle?.vin,
              color: missionData?.object_vehicle?.color,
              is_leasing: missionData?.object_vehicle?.is_leasing,
            }
          : null;
        // this.applications = missionData?.applications;
      }
    },
    makeData() {
      return {
        mission_type_id: this.selectedMissionType
          ? typeof this.selectedMissionType == "object"
            ? this.selectedMissionType.id
            : this.selectedMissionType
          : null,
        reference: this.reference,
        client_id: this.client_name
          ? typeof this.client_name == "object"
            ? this.client_name.id
            : null
          : null,
        contact: {
          id: this.contact?.id ?? null,
          name: this.contact?.name ?? null,
          gsm: this.contact?.gsm ?? null,
          phone: this.contact?.phone ?? null,
        },
        object_vehicle: this.computedVehicle
          ? this.computedVehicle.registration_number
            ? this.computedVehicle
            : null
          : null,
        towing_vehicle_id: this.towingVehicle
          ? typeof this.towingVehicle == "object"
            ? this.towingVehicle.id
            : this.towingVehicle
          : null,
        towing_partner_id: this.towingPartner
          ? typeof this.towingPartner == "object"
            ? this.towingPartner.id
            : this.towingPartner
          : null,
        towing_partner_employee_id: this.towingPartnerEmployee
          ? typeof this.towingPartnerEmployee == "object"
            ? this.towingPartnerEmployee.id
            : this.towingPartnerEmployee
          : null,

        source_location: this.sourceLocation ?? null,
        destination_location: this.destinationLocation ?? null,
        price: this.price,
        note: this.note,
        reason: this.reason,
        // status_id: this.status_id,
        selection_open_timer: this.selectionOpenTime,
        notify_partners: this.notify_partners,

        total_time: this.total_time ?? null,
        total_distance: this.total_distance ?? null,
        finished_at: this.convertIsoDateToBackendFormat(this.finished_at),
        check_in_time: this.convertIsoDateToBackendFormat(this.check_in_time),
        started_at: this.convertIsoDateToBackendFormat(this.started_at),
        for_date: this.convertIsoDateToBackendFormat(this.for_date),
        status_id: this.status_id
          ? typeof this.status_id == "object"
            ? this.status_id.id
            : this.status_id
          : null,
      };
    },
    onSubmit() {
      this.$store.commit("setValidation", true);
      if (!this.$v.$invalid && !this.$refs["vehicleComp"].$v.invalid) {
        if (this.$store.state.editId) {
          this.updateMission(this.makeData());
        } else {
          this.addMission(this.makeData());
        }
      } else {
        this.$toast.warning(this.$t("please_fill_form_correctly"));
      }
    },
    addMission(data) {
      axios
        .post(API_BASE_URL + "/missions", data, {
          headers: this.header,
        })
        .then(() => {
          this.$router.push("/mission").catch(() => {});
        });
    },
    updateMission(data, redirect = true) {
      return new Promise((resolve, reject) => {
        axios
          .put(API_BASE_URL + "/missions/" + this.$store.state.editId, data, {
            headers: this.header,
          })
          .then(({ data }) => {
            resolve(data?.data);
            if (redirect) {
              this.$router.push("/mission").catch(() => {});
            }
          })
          .catch(() => {
            reject();
          })
          .finally(() => {});
      });
    },
    async getMissionTypes() {
      await this.getCodes("mission_types", "mission.types");
      //   this.missionTypes = data;
      this.selectedMissionType = this.missionTypes[0]?.id;
    },
    fetchTowingPartnersListDebounced(autoSearch = false) {
      if (
        (!this.searchTowingPartner ||
          typeof this.searchTowingPartner == "object") &&
        autoSearch == false
      ) {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?towing_partner=1" +
            (this.searchTowingPartner
              ? "&search=" + encodeURIComponent(this.searchTowingPartner)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.towingPartners = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchTowingPartnerEmployeesListDebounced(autoSearch = false) {
      if (
        (!this.searchTowingPartnerEmployees ||
          typeof this.searchTowingPartnerEmployees == "object") &&
        autoSearch == false
      ) {
        return;
      }
      let towingPartnerRepresentativeId = this.towingPartner
        ? typeof this.towingPartner == "object"
          ? this.towingPartner.representative_company_id
          : this.towingPartner
        : null;
      if (!towingPartnerRepresentativeId) {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?membersOnly=1" +
            (towingPartnerRepresentativeId
              ? "&representative_company_id=" + towingPartnerRepresentativeId
              : "") +
            (this.searchTowingPartnerEmployees
              ? "&search=" +
                encodeURIComponent(this.searchTowingPartnerEmployees)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.towingPartnerEmployees = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },

    fetchTowingVehiclesListDebounced(autoSearch = false) {
      if (
        (!this.searchTowingVehicle ||
          typeof this.searchTowingVehicle == "object") &&
        autoSearch == false
      ) {
        return;
      }
      axios
        .get(
          API_BASE_URL +
            "/client_vehicles?" +
            (this.towingPartner
              ? "client_id=" +
                (typeof this.towingPartner == "object"
                  ? this.towingPartner.id
                  : this.towingPartner)
              : "") +
            (this.searchTowingVehicle
              ? "&search=" + encodeURIComponent(this.searchTowingVehicle)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.towingVehicles = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchClientsListDebounced() {
      if (!this.search_client || typeof this.search_client == "object") {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?" +
            (this.search_client
              ? "&search=" + encodeURIComponent(this.search_client)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.client_names = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
  watch: {
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal == true && this.confirmationDialogOperation != null) {
        if (
          this.confirmationDialogOperation == "make_bill_for_mission" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.makeBillForMission();
        }

        if (
          this.confirmationDialogOperation == "cancel_bill" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.cancelMission();
        }
        this.confirmationDialog = false;
        this.confirmationDialogButtonClickedIs = null;
      }
    },
    selectedMission: {
      handler: function (val) {
        if (val) {
          this.$store.commit("setSelectedMissionData", val);
        } else {
          this.$store.commit("setSelectedMissionData", null);
        }
      },
      immediate: true,
    },
    search_mission(val) {
      if (val && typeof val == "object") {
        this.search_mission = val.identifier;
        this.allowContinueSearch = false;
        return;
      }

      if (val && this.allowContinueSearch) {
        if (
          !val ||
          (this.selectedMission && this.selectedMission.identifier == val)
        ) {
          return;
        }
        this.isLoadingSearchRegMissions = true;
        this.fetchMissionSuggestedListDebounced();
      }
      this.allowContinueSearch = true;
    },
    search_client(val) {
      if (!val || this.client_id == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchClientsListDebounced();
      }, 500);
    },

    searchTowingPartnerEmployees(val) {
      if (!val || this.towingPartnerEmployee == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchTowingPartnerEmployeesListDebounced();
      }, 500);
    },

    searchTowingPartner(val) {
      if (!val || this.towingPartner == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchTowingPartnersListDebounced();
      }, 500);
    },

    searchTowingVehicle(val) {
      if (!val || this.towingVehicle == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchTowingVehiclesListDebounced();
      }, 500);
    },
  },
  computed: {
    currencySymbol() {
      return this.userCurrencySymbol;
    },
    computedVehicle() {
      return {
        id:
          (this.vehicle?.registration_number
            ? typeof this.vehicle?.registration_number == "object"
              ? this.vehicle?.registration_number.id
              : null
            : null) ?? this.vehicle?.id,
        vehicle_type_id: this.vehicle?.vehicle_type_id
          ? typeof this.vehicle?.vehicle_type_id == "object"
            ? this.vehicle?.vehicle_type_id.id
            : this.vehicle?.vehicle_type_id
          : null,
        registration_number: this.vehicle?.registration_number
          ? typeof this.vehicle?.registration_number == "object"
            ? this.vehicle?.registration_number.registration_number
            : this.vehicle?.registration_number
          : null,
        brand_id: this.vehicle?.brand
          ? typeof this.vehicle?.brand == "object"
            ? this.vehicle?.brand?.id
            : this.vehicle?.brand
          : typeof this.vehicle?.brand_id == "object"
          ? this.vehicle?.brand_id?.id
          : this.vehicle?.brand_id,
        model: this.vehicle?.model,
        km: this.vehicle?.km,
        registration_date: this.vehicle?.registration_date,
        creditor_id: this.vehicle?.creditor_id,
        vin: this.vehicle?.vin,
        color: this.vehicle?.color,
        is_leasing: this.vehicle?.is_leasing,
      };
    },
  },
};
</script>

<style scoped>
.client_name {
  font-size: 13px;
  margin: 0px;
}

.mission_type {
  font-size: 12px;
  margin: 0px;
}

.client_detail {
  font-size: 11px;
  margin-bottom: 2px;
}
</style>
